// TODO: REFACTORING!!!
//combine with phonemask

import { Controller } from '@stimulus/core'
import IMask from 'imask'

export default class extends Controller {
  connect() {
    IMask(this.element, {
      mask: Date,
      min: new Date(1900,0,1),
      lazy: false,
      placeholderChar: '0'
    })
  }
}
